<template>
  <div class="d-flex flex-row alert" :class="['alert-' + type]" role="alert">
    <div>
      <i v-if="type === 'danger'" class="fal fa-exclamation-circle fa-lg ml-2"></i>
      <i v-else-if="type === 'success'" class="fal fa-check-circle fa-lg"></i>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

type AlertType = 'primary' | 'success' | 'info' | 'warning' | 'secondary' | 'light' | 'dark' | 'danger';

@Component
export default class AlertComponent extends Vue {
  @Prop({ default: 'primary' }) type!: AlertType;
}

export { AlertComponent, AlertType };
</script>

<style>
.alert.alert-success {
  align-items: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-color: transparent;
  border-right: 5px solid #00ad68;
  border-radius: 4px;
  color: #00ad68;
  opacity: 1;
  padding: 0.5em 1.5em 0.5em 0.5em;
  gap: 1em;
}

.alert.alert-success .fal {
  font-size: 3rem;
  line-height: 1.75;
}

.alert.alert-danger {
  color: #ae351c;
  background-color: #dd33221a;
}
</style>
